// extracted by mini-css-extract-plugin
export default {"save-changes-button":"style_save-changes-button__8ruzX"};